import { styled } from "@givenwell/stitches";

export const UnstyledButton = styled("button", {});
